// import bckImg from '../../assets/images/landing_bg.jpg'

const styles = theme => ({
  animater: {
    backgroundColor: 'inherit'
  },
  animater2: {},
  logo2: {
    width: '10%',
    transition: 'height 750ms ease-in-out'
  },
  logoHidden: {
    width: '10%',
    opacity: 0,
    height: 0
  },
  app: {
    height: '100vh',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
    // backgroundColor: '#000000',
    // backgroundImage: `url(${bckImg})`
  }
})

export default styles
